import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { useLocation } from "react-router";
import { Link, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import classnames from "classnames";
import heic2any from "heic2any";
import $ from "jquery";

import { IMAGES } from "../../../constants";
import { url } from "../../../config";
import { ExtentionSupport } from "../../../utils/json";
import { validateFields } from "../../../validation";
import { getAttributes, addProduct, clearError, clearMessage, GetProductCount, getProductDetails } from "../../../actions/productActions";
import { getCategory } from "../../../actions/categoryAction";
import Loader from "../../layout/Loader";
import PopupSucess from "../../layout/PopupSucess";
import { getSecondLastURL, ImageUrl } from "../../../helper";
import { deleteImage } from "../../../utils/CommonApi";
import Select from "react-select";
import {
  PARCEL_LOT_MM,
  formatMmOptionValue,
  normalizeMmValues,
  normalizeParcelKey,
  parseProductMmValues,
  getParcelLotMmValues,
} from "../../../constants/parcelLot";
import { mmJson } from "../../../utils/json";

const queryString = require("query-string");

const MAX_IMAGE_LIMIT = 5;
const MAX_SIZE_BYTES = 10 * 1024 * 1024;

const formatMeasurementFromParts = (mm_l, mm_w, mm_h) => {
  const l = Number(mm_l);
  const w = Number(mm_w);
  const h = Number(mm_h);
  if (![l, w, h].every((n) => Number.isFinite(n))) return null;
  return {
    mm_l: l.toFixed(2),
    mm_w: w.toFixed(2),
    mm_h: h.toFixed(2),
    measurements: `${l.toFixed(2)}x${w.toFixed(2)}x${h.toFixed(2)}`,
  };
};

const mmValuesToJson = (values) => {
  const normalized = normalizeMmValues(values);
  if (normalized.length === 0) return null;
  return JSON.stringify(normalized);
};

const AddParcels = () => {
  const dispatch = useDispatch();
  const alert = useAlert();
  const intl = useIntl();
  const location = useLocation();
  const { id } = useParams();

  const parsed = queryString.parse(location.search);
  const category_slug_from_path = getSecondLastURL(location);
  const category_slug = id ? category_slug_from_path : parsed?.cat;

  const { attributes } = useSelector((state) => state.attributes);
  const { data, error, errormsg, loading } = useSelector((state) => state.productAdd);
  const productDetail = useSelector((state) => state.productDetails);

  const [checkFancy, setCheckFancy] = useState(false);
  const [images, setImages] = useState([]);
  const [imageToShow, setImageToShow] = useState([]);
  const [video, setVideo] = useState(null);
  const [deleteImgLoader, setDeleteImgLoader] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);
  const fileInputRef = useRef(null);
  const [selectedMmValues, setSelectedMmValues] = useState([]);

  const [addproduct, setAddProduct] = useState({
    category_slug: category_slug,
    stock_number: "",
    shape: "",
    carat: "",
    pieces: "",
    color: "",
    fancy_color: "",
    fancy_intensity: "",
    fancy_overtone: "",
    clarity: "",
    parcel: "",
    sieve: "",
    mm_l: "",
    mm_w: "",
    mm_h: "",
    certificate: "",
    certificate_number: "",
    price: "",
    comment: "",
    images: null,
    video: null,
  });

  const [validerror, setValidError] = useState({
    stock_numberError: "",
    shapeError: "",
    caratError: "",
    piecesError: "",
    colorError: "",
    fancy_colorError: "",
    fancy_intensityError: "",
    fancy_overtoneError: "",
    clarityError: "",
    parcelError: "",
    millimeterError: "",
    sieveError: "",
    mm_l_Error: "",
    mm_w_Error: "",
    mm_h_Error: "",
    certificateError: "",
    priceError: "",
  });

  useEffect(() => {
    if (!category_slug) return;
    dispatch(getAttributes(category_slug));
  }, [dispatch, category_slug]);

  useEffect(() => {
    if (!id) return;
    dispatch(getProductDetails(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (!id || !productDetail?.details?.productDetails) return;
    const p = productDetail.details.productDetails;
    const parcelKey = normalizeParcelKey(p?.parcel);

    const isFancy = String(p?.is_fancy || 0) === "1";
    setCheckFancy(isFancy);

    const lotMap =
      attributes?.parcel_lot_map && typeof attributes.parcel_lot_map === "object" && Object.keys(attributes.parcel_lot_map).length > 0
        ? attributes.parcel_lot_map
        : PARCEL_LOT_MM;

    const mappedMm = parcelKey ? getParcelLotMmValues(parcelKey, lotMap) : null;
    const mmFromProduct = parseProductMmValues(p?.mm);

    setAddProduct((prev) => ({
      ...prev,
      category_slug: category_slug,
      stock_number: p?.stock_number || "",
      shape: p?.a_shape?.attribute_id || "",
      carat: p?.carat || "",
      pieces: p?.pieces || "",
      color: !isFancy ? (p?.a_color?.attribute_id || "") : "",
      fancy_color: isFancy ? (p?.a_fancy_color?.attribute_id || "") : "",
      fancy_intensity: isFancy ? (p?.a_fancy_intensity?.attribute_id || "") : "",
      fancy_overtone: isFancy ? (p?.a_fancy_overtone?.attribute_id || "") : "",
      clarity: p?.a_clarity?.attribute_id || "",
      parcel: parcelKey,
      sieve: p?.a_sieve?.attribute_id || "",
      mm_l: p?.mm_l != null ? String(p.mm_l) : "",
      mm_w: p?.mm_w != null ? String(p.mm_w) : "",
      mm_h: p?.mm_h != null ? String(p.mm_h) : "",
      certificate: p?.a_certificate?.attribute_id || p?.certificate || "",
      certificate_number: p?.certificate_number || "",
      price: p?.price || "",
      comment: p?.comment || "",
    }));

    setSelectedMmValues(mappedMm && mappedMm.length > 0 ? mappedMm : mmFromProduct);

    if (productDetail?.details?.singleVideo?.video) {
      setVideo({
        url: ImageUrl(productDetail.details.singleVideo.video),
        id: productDetail.details.singleVideo.id,
      });
    } else {
      setVideo(null);
    }

    const imgs = productDetail?.details?.productImages?.map((i) => ({
      url: ImageUrl(i?.file),
      id: i?.id,
    }));
    setImageToShow(imgs || []);
    setImages([]);
  }, [id, productDetail?.details, category_slug, attributes?.parcel_lot_map]);

  const parcelLotMap = useMemo(() => {
    const fromApi = attributes?.parcel_lot_map;
    if (fromApi && typeof fromApi === "object" && Object.keys(fromApi).length > 0) {
      return fromApi;
    }
    return PARCEL_LOT_MM;
  }, [attributes?.parcel_lot_map]);

  const parcelLotOptions = useMemo(() => {
    const fromApi = attributes?.parcel_lot_options;
    const raw = Array.isArray(fromApi) && fromApi.length > 0 ? fromApi : Object.keys(parcelLotMap);
    const unique = [...new Set(raw.map((k) => normalizeParcelKey(k)).filter(Boolean))];
    const current = normalizeParcelKey(addproduct.parcel);
    if (current && !unique.includes(current)) {
      unique.unshift(current);
    }
    return unique;
  }, [attributes?.parcel_lot_options, parcelLotMap, addproduct.parcel]);

  const mmSelectOptions = useMemo(() => {
    const fromApi = attributes?.mm;
    if (Array.isArray(fromApi) && fromApi.length > 0) {
      return fromApi
        .map((opt) => {
          const raw = opt?.name ?? opt?.display_name ?? opt?.a_name ?? "";
          const value = formatMmOptionValue(raw);
          if (!value) return null;
          return { value, label: value };
        })
        .filter(Boolean)
        .sort((a, b) => Number(a.value) - Number(b.value));
    }
    return (mmJson || [])
      .map((opt) => {
        const value = formatMmOptionValue(opt?.display_name ?? opt?.value ?? "");
        if (!value) return null;
        return { value, label: value };
      })
      .filter(Boolean)
      .sort((a, b) => Number(a.value) - Number(b.value));
  }, [attributes?.mm]);

  const mmSelectValue = useMemo(
    () => selectedMmValues.map((v) => ({ value: v, label: v })),
    [selectedMmValues]
  );

  const isParcelMmLocked = Boolean(normalizeParcelKey(addproduct.parcel));

  useEffect(() => {
    const apiError = error || errormsg;
    if (!apiError) return;
    alert.error(apiError);
    dispatch(clearError());
  }, [alert, dispatch, error, errormsg]);

  useEffect(() => {
    if (!data) return;
    $("#popup-click-sucess").trigger("click");
    dispatch(clearMessage());
    setTimeout(() => {
      window.location = url + "/myproducts/parcels";
    }, 1500);
  }, [data, dispatch]);

  const convertArrayToFileList = (filesArray) => {
    const dt = new DataTransfer();
    filesArray?.forEach((fileObj) => dt.items.add(fileObj.file));
    return dt.files;
  };

  useEffect(() => {
    if (images?.length > 0) {
      setAddProduct((prev) => ({ ...prev, images: convertArrayToFileList(images) }));
    } else {
      setAddProduct((prev) => ({ ...prev, images: null }));
    }
  }, [images]);

  const check_duplicate = (name) => {
    if (images?.length > 0) {
      for (let i = 0; i < images.length; i++) {
        if (images[i]?.name === name) return false;
      }
    }
    if (imageToShow?.length > 0) {
      for (let i = 0; i < imageToShow.length; i++) {
        if (imageToShow[i]?.name === name) return false;
      }
    }
    return true;
  };

  const image_select = async (e) => {
    setImgLoading(true);
    const files = e?.target?.files;
    let remaining = MAX_IMAGE_LIMIT - imageToShow.length;
    if (remaining <= 0) {
      setImgLoading(false);
      return;
    }

    const tempImgArr = [];
    const tempImgArrShow = [];
    const max_len = files?.length > remaining ? remaining : files?.length;

    for (let i = 0; i < max_len; i++) {
      let file = files[i];
      const fileName = file?.name;
      const fileType = fileName?.split(".").pop();

      if (!ExtentionSupport.includes(fileType)) {
        alert.error(fileName + " has an unsupported file format.");
        continue;
      }
      if (file?.size > MAX_SIZE_BYTES) {
        alert.error(fileName + " exceeds the 10MB size limit");
        continue;
      }
      if (!check_duplicate(fileName)) {
        alert.error(fileName + " is already added to the list");
        continue;
      }

      if (fileType === "heic" || fileType === "heif") {
        try {
          const convertedBlob = await heic2any({ blob: file, toType: "image/jpeg" });
          file = new File([convertedBlob], fileName.replace(/\.(heic|heif)$/i, ".jpg"), { type: "image/jpeg" });
        } catch (err) {
          alert.error("Failed to convert HEIC file: " + fileName);
          continue;
        }
      }

      tempImgArrShow.push({
        name: fileName,
        url: URL.createObjectURL(file),
        size: file.size,
        id: "",
      });
      tempImgArr.push({
        name: fileName,
        url: URL.createObjectURL(file),
        file: file,
        size: file.size,
      });
    }

    setImageToShow((prev) => [...prev, ...tempImgArrShow]);
    setImages((prev) => [...prev, ...tempImgArr]);
    if (fileInputRef.current) fileInputRef.current.value = "";
    setImgLoading(false);
  };

  const video_select = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    const ext = file?.name?.split(".").pop();
    if (ext !== "mp4") {
      alert.error("Please upload supported file format");
      return;
    }
    const videoUrl = URL.createObjectURL(file);
    setAddProduct((prev) => ({ ...prev, video: file }));
    setVideo({ url: videoUrl, id: "" });
    const videor = document.getElementById("video");
    if (videor) {
      let source = videor.querySelector("source");
      if (!source) {
        source = document.createElement("source");
        source.setAttribute("type", "video/mp4");
        videor.appendChild(source);
      }
      source.setAttribute("src", videoUrl);
      videor.load();
    }
  };

  const deleteImgOrVideo = async (assetId, type) => {
    setDeleteImgLoader(true);
    try {
      await deleteImage({ id: assetId, type });
    } finally {
      setDeleteImgLoader(false);
    }
  };

  const delete_image = (index, assetId) => {
    if (assetId) {
      deleteImgOrVideo(assetId, "img");
    }
    const removed = imageToShow[index];
    setImageToShow((prev) => prev.filter((x, i) => i !== index));
    if (removed?.name) {
      setImages((prev) => prev.filter((img) => img.name !== removed.name));
    }
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const delete_video = (assetId) => {
    if (assetId) {
      deleteImgOrVideo(assetId, "video");
    }
    setVideo(null);
    $("#video_upload").val("");
    setAddProduct((prev) => ({ ...prev, video: null }));
  };

  const handleSwitchFancy = (e) => {
    const checked = e.target.checked;
    setCheckFancy(checked);
    if (checked) {
      setAddProduct((prev) => ({
        ...prev,
        color: "",
      }));
    } else {
      setAddProduct((prev) => ({
        ...prev,
        fancy_color: "",
        fancy_intensity: "",
        fancy_overtone: "",
      }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValidError((prev) => ({
      ...prev,
      stock_numberError: "",
      shapeError: "",
      caratError: "",
      piecesError: "",
      colorError: "",
      fancy_colorError: "",
      fancy_intensityError: "",
      fancy_overtoneError: "",
      clarityError: "",
      parcelError: "",
      millimeterError: "",
      sieveError: "",
      mm_l_Error: "",
      mm_w_Error: "",
      mm_h_Error: "",
      certificateError: "",
      priceError: "",
    }));

    setAddProduct((prev) => ({ ...prev, [name]: value }));
  };

  const handleParcelChange = (e) => {
    const value = normalizeParcelKey(e.target.value);
    setValidError((prev) => ({ ...prev, parcelError: "", millimeterError: "" }));
    setAddProduct((prev) => ({ ...prev, parcel: value }));

    if (!value) {
      return;
    }
    const mapped = getParcelLotMmValues(value, parcelLotMap);
    if (mapped && mapped.length > 0) {
      setSelectedMmValues(mapped);
    }
  };

  const handleMillimeterMultiChange = (selected) => {
    if (isParcelMmLocked) return;
    setValidError((prev) => ({ ...prev, millimeterError: "" }));
    const next = selected ? selected.map((opt) => opt.value) : [];
    setSelectedMmValues(normalizeMmValues(next));
  };

  const stockNumberErrorFor = (stock_number) => {
    const raw = String(stock_number ?? "").trim();
    if (!raw) {
      return intl.formatMessage({ id: "error.stock_number", defaultMessage: "stock number is required" });
    }
    if (raw.length > 20) {
      return intl.formatMessage({
        id: "error.stock_number_max",
        defaultMessage: "Stock number cannot exceed 20 characters",
      });
    }
    return false;
  };

  const piecesErrorFor = (pieces) => {
    const raw = String(pieces ?? "").trim();
    if (!raw) {
      return intl.formatMessage({ id: "error.pieces", defaultMessage: "pieces is required" });
    }
    if (raw.length > 20) {
      return intl.formatMessage({
        id: "error.pieces_max",
        defaultMessage: "Pieces cannot exceed 20 characters",
      });
    }
    if (!/^\d+$/.test(raw)) {
      return intl.formatMessage({
        id: "error.pieces_integer",
        defaultMessage: "Pieces must be a whole number (no decimals)",
      });
    }
    const num = Number(raw);
    if (!Number.isFinite(num) || num <= 0) {
      return intl.formatMessage({
        id: "error.pieces_zero",
        defaultMessage: "Pieces must be greater than 0",
      });
    }
    return false;
  };

  const priceCtErrorFor = (price) => {
    const raw = String(price ?? "").trim();
    if (!raw) {
      return intl.formatMessage({ id: "error.price", defaultMessage: "Price/ct is required" });
    }
    if (raw.length > 20) {
      return intl.formatMessage({
        id: "error.price_max",
        defaultMessage: "Price/ct cannot exceed 20 characters",
      });
    }
    const regex = /^\d*\.?\d*$/;
    if (!regex.test(raw)) {
      return <FormattedMessage id="error.numeric" defaultMessage="Only numeric digits and  period is allowed" />;
    }
    const num = Number(raw);
    if (!Number.isFinite(num) || num <= 0) {
      return intl.formatMessage({
        id: "error.price_zero",
        defaultMessage: "Price/ct must be greater than 0",
      });
    }
    return false;
  };

  const AVE_CT_MAX_LENGTH = 8;

  const aveCtErrorFor = (carat) => {
    const raw = String(carat ?? "").trim();
    if (!raw) {
      return intl.formatMessage({ id: "error.aveCT", defaultMessage: "Ave./CT is required" });
    }
    if (raw.length > AVE_CT_MAX_LENGTH) {
      return intl.formatMessage({
        id: "error.aveCT_max",
        defaultMessage: "Ave./CT cannot exceed 8 characters",
      });
    }
    const regex = /^\d*\.?\d*$/;
    if (!regex.test(raw)) {
      return <FormattedMessage id="error.numeric" defaultMessage="Only numeric digits and  period is allowed" />;
    }
    const num = Number(raw);
    if (!Number.isFinite(num) || num <= 0) {
      return intl.formatMessage({ id: "error.aveCT_zero", defaultMessage: "Ave./CT must be greater than 0" });
    }
    return false;
  };

  const millimeterErrorFor = (mmValues, parcelValue) => {
    if (normalizeMmValues(mmValues).length > 0) return false;
    if (!parcelValue) {
      return intl.formatMessage({
        id: "error.millimeter",
        defaultMessage: "Millimeter is required when Parcel is not selected",
      });
    }
    return intl.formatMessage({
      id: "error.millimeter",
      defaultMessage: "Millimeter is required",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const stock_numberError = stockNumberErrorFor(addproduct.stock_number);
    const shapeError = validateFields.validateShape(addproduct.shape);
    const caratError = aveCtErrorFor(addproduct.carat);
    const piecesError = piecesErrorFor(addproduct.pieces);
    const clarityError = validateFields.validateClarity(addproduct.clarity);
    const parcelError = false;
    const millimeterError = millimeterErrorFor(selectedMmValues, normalizeParcelKey(addproduct.parcel));
    const sieveError = validateFields.validateSieve(addproduct.sieve);
    const certificateError = validateFields.validateCertificate(addproduct.certificate);
    const priceError = priceCtErrorFor(addproduct.price);
    let mm_l_Error = false;
    let mm_w_Error = false;
    let mm_h_Error = false;
    const anyMeasurementFilled = Boolean(addproduct.mm_l || addproduct.mm_w || addproduct.mm_h);
    const allMeasurementFilled = Boolean(addproduct.mm_l && addproduct.mm_w && addproduct.mm_h);
    if (anyMeasurementFilled && !allMeasurementFilled) {
      const msg = intl.formatMessage({
        id: "error.measurement_all_or_blank",
        defaultMessage: "Please either fill in all the measurements or leave them all blank.",
      });
      mm_l_Error = addproduct.mm_l ? false : msg;
      mm_w_Error = addproduct.mm_w ? false : msg;
      mm_h_Error = addproduct.mm_h ? false : msg;
    } else if (allMeasurementFilled) {
      mm_l_Error = validateFields.validateMm_l(addproduct.mm_l);
      mm_w_Error = validateFields.validateMm_w(addproduct.mm_w);
      mm_h_Error = validateFields.validateMn_h(addproduct.mm_h);
    }

    let colorError = false;
    let fancy_colorError = false;
    let fancy_intensityError = false;
    let fancy_overtoneError = false;

    if (!checkFancy) {
      colorError = validateFields.validateColor(addproduct.color);
    } else {
      fancy_colorError = validateFields.validateFancyColor(addproduct.fancy_color);
      fancy_intensityError = validateFields.validateFancyColorIntensity(addproduct.fancy_intensity);
      fancy_overtoneError = validateFields.validateFancyColorOvertone(addproduct.fancy_overtone);
    }

    const errors = [
      stock_numberError,
      shapeError,
      caratError,
      piecesError,
      clarityError,
      parcelError,
      millimeterError,
      sieveError,
      mm_l_Error,
      mm_w_Error,
      mm_h_Error,
      certificateError,
      priceError,
      colorError,
      fancy_colorError,
      fancy_intensityError,
      fancy_overtoneError,
    ];

    if (!errors.every((x) => x === false)) {
      setValidError((prev) => ({
        ...prev,
        stock_numberError,
        shapeError,
        caratError,
        piecesError,
        clarityError,
        parcelError,
        millimeterError,
        sieveError,
        mm_l_Error,
        mm_w_Error,
        mm_h_Error,
        certificateError,
        priceError,
        colorError,
        fancy_colorError,
        fancy_intensityError,
        fancy_overtoneError,
      }));
      return;
    }

    const mmJson = mmValuesToJson(selectedMmValues);
    const measurementParsed = allMeasurementFilled ? formatMeasurementFromParts(addproduct.mm_l, addproduct.mm_w, addproduct.mm_h) : null;

    const parcelKey = normalizeParcelKey(addproduct.parcel);

    const payload = {
      ...addproduct,
      category_slug,
      stock_number: String(addproduct.stock_number || "").trim(),
      parcel: parcelKey || null,
      mm: mmJson,
      ...(measurementParsed || {}),
    };

    if (!checkFancy) {
      payload.fancy_color = "";
      payload.fancy_intensity = "";
      payload.fancy_overtone = "";
    } else {
      payload.color = "";
    }

    delete payload.bgm;

    if (id) {
      payload.id = id;
    }

    await dispatch(addProduct(payload));
    dispatch(GetProductCount());
    dispatch(getCategory());
  };

  const titleText = useMemo(() => {
    if (id) return intl.formatMessage({ id: "addsingleproduct.editproduct", defaultMessage: "Edit product" });
    return intl.formatMessage({ id: "addsingleproduct.add-a-single", defaultMessage: "Add a Single" });
  }, [id, intl]);

  return (
    <Fragment>
      {(loading || productDetail?.loading || deleteImgLoader || imgLoading) && <Loader />}

      <h3 className="forms">
        {titleText} <span>{` `}</span>
        <FormattedMessage id="category.parcels" defaultMessage="Parcels" />
      </h3>

      <form onSubmit={handleSubmit}>
        {/* Row 1: Stock No + Shape */}
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>
                <FormattedMessage id="addsingleproduct.stockno" defaultMessage="Stock No." /> <span className="strike_red">*</span>
              </label>
              <input
                className={classnames("form-control", { "is-valid": validerror.stock_numberError === false }, { "is-invalid": validerror.stock_numberError })}
                type="text"
                name="stock_number"
                maxLength={20}
                placeholder={intl.formatMessage({ id: "Enter Stock No", defaultMessage: "Enter Stock No." })}
                value={addproduct.stock_number}
                onChange={handleInputChange}
              />
              <p className="invalid-feedback">{validerror.stock_numberError}</p>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="form-group">
              <label>
                <FormattedMessage id="addsingleproduct.shape" defaultMessage="Shape" /> <span className="strike_red">*</span>
              </label>
              <select
                className={classnames("form-control", { "is-valid": validerror.shapeError === false }, { "is-invalid": validerror.shapeError })}
                name="shape"
                value={addproduct.shape}
                onChange={handleInputChange}
              >
                <FormattedMessage id="addsingleproduct.chooseshape" defaultMessage="Choose">
                  {(id) => <option value="">{id}</option>}
                </FormattedMessage>
                {attributes?.shape?.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.name}
                  </option>
                ))}
              </select>
              <p className="invalid-feedback">{validerror.shapeError}</p>
            </div>
          </div>
        </div>

        {/* Row 2: Avg./CT + Pieces */}
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>
                <FormattedMessage id="addsingleproduct.aveCT" defaultMessage="Ave./CT" /> <span className="strike_red">*</span>
              </label>
              <input
                className={classnames("form-control", { "is-valid": validerror.caratError === false }, { "is-invalid": validerror.caratError })}
                type="text"
                name="carat"
                maxLength={AVE_CT_MAX_LENGTH}
                placeholder={intl.formatMessage({ id: "Enter Ave./CT", defaultMessage: "Enter Ave./CT" })}
                value={addproduct.carat}
                onChange={handleInputChange}
              />
              <p className="invalid-feedback">{validerror.caratError}</p>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="form-group">
              <label>
                <FormattedMessage id="Pieces" defaultMessage="Pieces" /> <span className="strike_red">*</span>
              </label>
              <input
                className={classnames("form-control", { "is-valid": validerror.piecesError === false }, { "is-invalid": validerror.piecesError })}
                type="text"
                name="pieces"
                maxLength={20}
                placeholder={intl.formatMessage({ id: "Enter Pieces", defaultMessage: "Enter Pieces" })}
                value={addproduct.pieces}
                onChange={handleInputChange}
              />
              <p className="invalid-feedback">{validerror.piecesError}</p>
            </div>
          </div>
        </div>

        {/* Row 3: White = Color + Clarity | Fancy = Fancy Color + Fancy Intensity */}
        <div className="row align-items-start">
          <div className="col-lg-4">

              <div className="form-group">
                <label className="d-flex justify-content-between">
                {!checkFancy ? (
                  <div>
                  <FormattedMessage id="addsingleproduct.color" defaultMessage="Color" /> <span className="strike_red">*</span>
                  </div>
                ) : (
                  <div>
                  <FormattedMessage id="addsingleproduct.fancycolor" defaultMessage="Fancy Color" /> <span className="strike_red">*</span>
                  </div>
                )}

                <div className="switch_color mr-0">
                  <div className="cus_switch d-flex align-item-center margin-top-0">
                    <p className="font-14 fm black-3B pr-3">
                      <FormattedMessage id="addsingleproduct.White" defaultMessage="White" />
                    </p>
                    <label className="switch mb-0">
                      <input type="checkbox" checked={checkFancy} onChange={handleSwitchFancy} />
                      <span className="slider round"></span>
                    </label>
                    <p className="gray-75 font-14 fm pl-3">
                      <FormattedMessage id="addsingleproduct.Fancy" defaultMessage="Fancy" />
                    </p>
                  </div>
                </div>

                </label>
                {!checkFancy ? (
                  <>
                  <select
                    className={classnames("form-control", { "is-valid": validerror.colorError === false }, { "is-invalid": validerror.colorError })}
                    name="color"
                    value={addproduct.color}
                    onChange={handleInputChange}
                  >
                    <FormattedMessage id="addsingleproduct.choosecolor" defaultMessage="Choose">
                      {(id) => <option value="">{id}</option>}
                    </FormattedMessage>
                    {attributes?.color?.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                        {opt.name}
                      </option>
                    ))}
                  </select>
                  <p className="invalid-feedback">{validerror.colorError}</p>
                  </>
                ) :
                <>
                  <select
                    className={classnames("form-control", { "is-valid": validerror.fancy_colorError === false }, { "is-invalid": validerror.fancy_colorError })}
                    name="fancy_color"
                    value={addproduct.fancy_color}
                    onChange={handleInputChange}
                  >
                    <FormattedMessage id="addsingleproduct.choosefancycolor" defaultMessage="Choose">
                      {(id) => <option value="">{id}</option>}
                    </FormattedMessage>
                    {attributes?.fancy_color?.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                        {opt.name}
                      </option>
                    ))}
                  </select>
                  <p className="invalid-feedback">{validerror.fancy_colorError}</p>
                </>
                }
              </div>
          </div>

          {!checkFancy ? (
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <FormattedMessage id="addsingleproduct.clarity" defaultMessage="Clarity" /> <span className="strike_red">*</span>
                </label>
                <select
                  className={classnames("form-control", { "is-valid": validerror.clarityError === false }, { "is-invalid": validerror.clarityError })}
                  name="clarity"
                  value={addproduct.clarity}
                  onChange={handleInputChange}
                >
                  <FormattedMessage id="addsingleproduct.chooseclarity" defaultMessage="Choose">
                    {(id) => <option value="">{id}</option>}
                  </FormattedMessage>
                  {attributes?.clarity?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
                <p className="invalid-feedback">{validerror.clarityError}</p>
              </div>
            </div>
          ) : (
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <FormattedMessage id="addsingleproduct.fancycolorintensity" defaultMessage="Fancy Intensity" /> <span className="strike_red">*</span>
                </label>
                <select
                  className={classnames("form-control", { "is-valid": validerror.fancy_intensityError === false }, { "is-invalid": validerror.fancy_intensityError })}
                  name="fancy_intensity"
                  value={addproduct.fancy_intensity}
                  onChange={handleInputChange}
                >
                  <FormattedMessage id="addsingleproduct.choosefancycolorintensity" defaultMessage="Choose">
                    {(id) => <option value="">{id}</option>}
                  </FormattedMessage>
                  {attributes?.fancy_intensity?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
                <p className="invalid-feedback">{validerror.fancy_intensityError}</p>
              </div>
            </div>
          )}
        </div>

        {/* Fancy row 2: Overtone + Clarity */}
        {checkFancy ? (
          <div className="row">
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <FormattedMessage id="addsingleproduct.fancycolorovertone" defaultMessage="Fancy Overtone" /> <span className="strike_red">*</span>
                </label>
                <select
                  className={classnames("form-control", { "is-valid": validerror.fancy_overtoneError === false }, { "is-invalid": validerror.fancy_overtoneError })}
                  name="fancy_overtone"
                  value={addproduct.fancy_overtone}
                  onChange={handleInputChange}
                >
                  <FormattedMessage id="addsingleproduct.choosefancycolorovertone" defaultMessage="Choose">
                    {(id) => <option value="">{id}</option>}
                  </FormattedMessage>
                  {attributes?.fancy_overtone?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
                <p className="invalid-feedback">{validerror.fancy_overtoneError}</p>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <FormattedMessage id="addsingleproduct.clarity" defaultMessage="Clarity" /> <span className="strike_red">*</span>
                </label>
                <select
                  className={classnames("form-control", { "is-valid": validerror.clarityError === false }, { "is-invalid": validerror.clarityError })}
                  name="clarity"
                  value={addproduct.clarity}
                  onChange={handleInputChange}
                >
                  <FormattedMessage id="addsingleproduct.chooseclarity" defaultMessage="Choose">
                    {(id) => <option value="">{id}</option>}
                  </FormattedMessage>
                  {attributes?.clarity?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
                <p className="invalid-feedback">{validerror.clarityError}</p>
              </div>
            </div>
          </div>
        ) : null}

        {/* Row 5: Parcel + Millimeter */}
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label className="parcel-field-label">
                <FormattedMessage id="Parcel" defaultMessage="Parcel" />
                <i
                  className="fa fa-info-circle parcel-info-icon ml-1"
                  aria-hidden="true"
                  title={intl.formatMessage({
                    id: "parcel.info_title",
                    defaultMessage: "List of acceptable values:(- 2) = 0.60, 0.70, 0.80, 0.90, 1.00, 1.10, 1.20, (-6.50) = 1.25, 1.30, 1.40, 1.50, 1.60, 1.70, (+6.5, -8) = 1.80, 1.90, 2.00, (+6.5, +8, -9) = 2.10, 2.20, 2.25, (+6.5, +9, -11) = 2.30, 2.40, 2.50, 2.60, (+11, -12) = 2.70, 2.80, 2.90, (+12, -14) = 2.90, 3.00, 3.10, 3.20, 3.30, (+14) = 3.30, 3.40, 3.50",
                  })}
                />
              </label>
              <select
                className={classnames("form-control", { "is-valid": validerror.parcelError === false }, { "is-invalid": validerror.parcelError })}
                name="parcel"
                value={normalizeParcelKey(addproduct.parcel)}
                onChange={handleParcelChange}
              >
                <FormattedMessage id="Choose" defaultMessage="Choose">
                  {(label) => <option value="">{label}</option>}
                </FormattedMessage>
                {parcelLotOptions.map((lotKey) => (
                  <option key={lotKey} value={lotKey}>
                    {lotKey}
                  </option>
                ))}
              </select>
              <p className="invalid-feedback">{validerror.parcelError}</p>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="form-group">
              <label>
                <FormattedMessage id="Millimeter" defaultMessage="Millimeter" />
                {!normalizeParcelKey(addproduct.parcel) ? <span className="strike_red">*</span> : null}
              </label>
              <Select
                isMulti
                name="millimeter"
                options={mmSelectOptions}
                value={mmSelectValue}
                onChange={handleMillimeterMultiChange}
                isDisabled={isParcelMmLocked}
                isClearable={!isParcelMmLocked}
                menuIsOpen={isParcelMmLocked ? false : undefined}
                className={classnames("parcel-mm-select", {
                  "is-invalid": validerror.millimeterError,
                  "parcel-mm-locked": isParcelMmLocked,
                })}
                classNamePrefix="parcel-mm"
                placeholder={
                  isParcelMmLocked
                    ? intl.formatMessage({
                        id: "mm_parcel_locked_placeholder",
                        defaultMessage: "Set automatically from Parcel",
                      })
                    : intl.formatMessage({
                        id: "mm_multiselect_placeholder",
                        defaultMessage: "Select millimeter values",
                      })
                }
                closeMenuOnSelect={false}
              />
              <p className="invalid-feedback d-block">{validerror.millimeterError}</p>
            </div>
          </div>
        </div>

        {/* Row 6: Sieve + Measurement (L/W/H) */}
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>
                <FormattedMessage id="Sieve" defaultMessage="Sieve" /> <span className="strike_red">*</span>
              </label>
              <select
                className={classnames("form-control", { "is-valid": validerror.sieveError === false }, { "is-invalid": validerror.sieveError })}
                name="sieve"
                value={addproduct.sieve}
                onChange={handleInputChange}
              >
                <FormattedMessage id="Choose" defaultMessage="Choose">
                  {(id) => <option value="">{id}</option>}
                </FormattedMessage>
                {attributes?.sieve?.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.name}
                  </option>
                ))}
              </select>
              <p className="invalid-feedback">{validerror.sieveError}</p>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="form-group">
              <label>
                <FormattedMessage id="addsingleproduct.measurement" defaultMessage="Measurement" />
              </label>
              <div className="row">
                <div className="col-md-4 mb-md-0 mb-3">
                  <input
                    type="text"
                    className={classnames("form-control", { "is-valid": validerror.mm_l_Error === false }, { "is-invalid": validerror.mm_l_Error })}
                    placeholder="length"
                    name="mm_l"
                    value={addproduct.mm_l}
                    onChange={handleInputChange}
                  />
                  {validerror.mm_l_Error ? <p className="invalid-feedback d-block">{validerror.mm_l_Error}</p> : null}
                </div>
                <div className="col-md-4 mb-md-0 mb-3">
                  <input
                    type="text"
                    className={classnames("form-control", { "is-valid": validerror.mm_w_Error === false }, { "is-invalid": validerror.mm_w_Error })}
                    placeholder="width"
                    name="mm_w"
                    value={addproduct.mm_w}
                    onChange={handleInputChange}
                  />
                  {validerror.mm_w_Error ? <p className="invalid-feedback d-block">{validerror.mm_w_Error}</p> : null}
                </div>
                <div className="col-md-4 mb-md-0 mb-0">
                  <input
                    type="text"
                    className={classnames("form-control", { "is-valid": validerror.mm_h_Error === false }, { "is-invalid": validerror.mm_h_Error })}
                    placeholder="depth"
                    name="mm_h"
                    value={addproduct.mm_h}
                    onChange={handleInputChange}
                  />
                  {validerror.mm_h_Error ? <p className="invalid-feedback d-block">{validerror.mm_h_Error}</p> : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Row 7: Certificate + Certificate No */}
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>
                <FormattedMessage id="addsingleproduct.certificate" defaultMessage="Certificate" /> <span className="strike_red">*</span>
              </label>
              <select
                className={classnames("form-control", { "is-valid": validerror.certificateError === false }, { "is-invalid": validerror.certificateError })}
                name="certificate"
                value={addproduct.certificate}
                onChange={handleInputChange}
              >
                <FormattedMessage id="addsingleproduct.choosecertificate" defaultMessage="Choose">
                  {(id) => <option value="">{id}</option>}
                </FormattedMessage>
                {attributes?.certificate?.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.name}
                  </option>
                ))}
              </select>
              <p className="invalid-feedback">{validerror.certificateError}</p>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="form-group">
              <label>
                <FormattedMessage id="addsingleproduct.certificate-no" defaultMessage="Cetificate No." />
              </label>
              <input
                className="form-control"
                type="text"
                name="certificate_number"
                placeholder={intl.formatMessage({ id: "Enter Certificate No", defaultMessage: "Enter Certificate No." })}
                value={addproduct.certificate_number}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>

        {/* Row 8: Price/ct */}
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>
                <FormattedMessage id="addsingleproduct.price-ct" defaultMessage="Price/ct" /> <span className="strike_red">*</span>
              </label>
              <input
                className={classnames("form-control", { "is-valid": validerror.priceError === false }, { "is-invalid": validerror.priceError })}
                type="text"
                name="price"
                maxLength={20}
                placeholder={intl.formatMessage({ id: "Enter Price", defaultMessage: "Enter Price" })}
                value={addproduct.price}
                onChange={handleInputChange}
              />
              <p className="invalid-feedback">{validerror.priceError}</p>
            </div>
          </div>
        </div>

        {/* Row 9: Comment */}
        <div className="row">
          <div className="col-lg-8">
            <div className="form-group">
              <label>
                <FormattedMessage id="addsingleproduct.comment" defaultMessage="Supplier Comment (optional)" />
              </label>
              <textarea className="form-control" rows="5" maxLength={300} name="comment" value={addproduct.comment} onChange={handleInputChange} />
            </div>
          </div>
        </div>

        <h3 className="forms toBrdr">
          <FormattedMessage id="addsingleproduct.uploadimage" defaultMessage="Upload Product Photos" />
          <p>
            <FormattedMessage id="addsingleproduct.supported-image" defaultMessage="JPEG, PNG supported, max 10mb per image" />
          </p>
        </h3>

        <div className="uploaded-product-grid">
          <div className="row">
            {imageToShow?.map((img, key) => (
              <div key={key} className="col-sm-6 col-lg-4 col-xl-3 mb-4">
                <div className="imgEdits">
                  <div className="imgBlock">
                    <img className="w-100" src={img.url} alt="" />
                    <div className="hover">
                      <img onClick={() => delete_image(key, img.id)} src={IMAGES.CLOSE_WHITE} alt="" />
                    </div>
                  </div>
                  {img?.size ? (
                    <div className="col-md-8 pro-ttl-ct">
                      <h4>{img?.name}</h4>
                      <p className="mb-10">
                        <FormattedMessage id="addsingleproduct.ImageUploaded" defaultMessage="Image Uploaded" /> ({img?.size / 1024}kb)
                      </p>
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>

        {imageToShow?.length < MAX_IMAGE_LIMIT ? (
          <div className="row imgEdits mb-4">
            <div className="col-md-4">
              <div className="moreUpload">
                <span>
                  <img src={IMAGES.DOWNLOAD_SVG} alt="" />
                </span>
                <FormattedMessage id="addsingleproduct.drop-photo" defaultMessage="Drop Photos" />
                <input
                  type="file"
                  name="Image"
                  id="image"
                  accept=".png,.jpg,.jpeg,.heic,.heif"
                  multiple
                  onChange={image_select}
                  ref={fileInputRef}
                />
              </div>
            </div>
          </div>
        ) : null}

        <h3 className="forms toBrdr">
          <FormattedMessage id="addsingleproduct.uploadvideo" defaultMessage="Upload Product Video" />
          <p>
            <FormattedMessage id="addsingleproduct.Mp4supported" defaultMessage="Mp4 supported" />
          </p>
        </h3>

        {video ? (
          <div className="col-md-4 imgEdits">
            <div className="row imgBlock videoEdits mb-4">
              <div className="close-vid hover">
                <img onClick={() => delete_video(video?.id)} src={IMAGES.CLOSE_WHITE} alt="" />
              </div>
              <video id="video" style={{ maxWidth: "100%" }}>
                <source src={video?.url} type="video/mp4" />
                <FormattedMessage id="addsingleproduct.YourBrowserNotSupport" defaultMessage="Your browser does not support the video tag." />
              </video>
            </div>
          </div>
        ) : (
          <div className="row imgEdits mb-4 videoUploadDiv">
            <div className="col-md-4">
              <div className="moreUpload">
                <span>
                  <img src={IMAGES.DOWNLOAD_SVG} alt="" />
                </span>
                <FormattedMessage id="addsingleproduct.drop-videos" defaultMessage="Drop Video" />
                <input type="file" accept=".mp4" name="video_upload" id="video_upload" onChange={video_select} />
              </div>
            </div>
          </div>
        )}

        <div className="row actions my-5">
          <div className="col-md-6">
            <Link className="btns outline mb-2 mr-2" style={{ textAlign: "center" }} to={url + "/myproducts/parcels"}>
              <FormattedMessage id="addsingleproduct.cancel" defaultMessage="Cancel" />
            </Link>
            <button type="submit" className="btn btn-blue mb-2">
              {id ? (
                <FormattedMessage id="Save" defaultMessage="Save" />
              ) : (
                <FormattedMessage id="addsingleproduct.addproduct" defaultMessage="Add Products" />
              )}
            </button>
          </div>
        </div>
      </form>

      {data && <PopupSucess title={"SUCCESS"} props={data} />}
    </Fragment>
  );
};

export default AddParcels;

